// import React, { useEffect, useRef, useState } from "react";
// import QuestionaireDownload from "../../common/QuestionaireDownload";
// import {
//   fetchDocumentOption,
//   fetchSampleDocumentDetails,
//   uploadDocuments,
// } from "../../../services/user.services";
// import { useDispatch, useSelector } from "react-redux";
// import Loader from "../../admin/leads/Loader";
// import { Cloud, FileText, XCircle, Download, ChevronDown } from "lucide-react";
// import { getStudentDetails } from "../../../services/admin.services";
// import { setUserDetails } from "../../../state/reducers/userSlice";

// const LOR = () => {
//   const dispatch = useDispatch();
//   const user_id = useSelector((state) => state.user.user_id);
//   const socket = useSelector((state) => state.user.socket);
//   const studentDetails = useSelector((state) => state.user.userDetails);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [lorFiles, setLorFiles] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const fileInputRefs = useRef({});
//   const [studentLevels, setStudentLevels] = useState([]);
//   const fetchLevels = async () => {
//     try {
//       const data = await fetchDocumentOption();
//       const levels = [...new Set(data.map((item) => item.student_level))];
//       setStudentLevels(levels);
//     } catch (error) {
//       console.error("Error fetching document options:", error);
//     }
//   };
//   useEffect(() => {
//     fetchLevels();
//   }, []);

//   // Initialize LOR fields dynamically based on existing lor_url length
//   useEffect(() => {
//     if (studentDetails?.lor_url) {
//       setLorFiles(
//         studentDetails.lor_url.map((url, index) => ({
//           id: index + 1,
//           name: url.split(/[/\\]/).pop(),
//           progress: 100,
//           status: "completed",
//         }))
//       );
//     }
//   }, [studentDetails.lor_url]);

//   // Add new LOR field dynamically
//   const addMoreLor = () => {
//     setLorFiles((prev) => [
//       ...prev,
//       { id: prev.length + 1, name: "", progress: 0, status: "idle" },
//     ]);
//   };

//   const handleFileChange = (event) => {
//     const files = Array.from(event.target.files);
//     const newLorFiles = files.map((file, index) => ({
//       id: lorFiles.length + index + 1,
//       name: file.name,
//       progress: 0,
//       status: "uploading",
//       file,
//     }));

//     setLorFiles((prev) => [...prev, ...newLorFiles]);

//     newLorFiles.forEach((lor) => uploadFile(lor.id, lor.file));
//   };

//   // Simulate upload progress (Replace with actual upload API call)
//   const uploadFile = (id, file) => {
//     const interval = setInterval(() => {
//       setLorFiles((prevFiles) =>
//         prevFiles.map((lor) => {
//           if (lor.id === id) {
//             if (lor.progress >= 100) {
//               clearInterval(interval);
//               return { ...lor, progress: 100, status: "completed" };
//             }
//             return { ...lor, progress: lor.progress + 5 };
//           }
//           return lor;
//         })
//       );
//     }, 50);
//   };

//   const getStudentProfile = async (user_id) => {
//     try {
//       const res = await getStudentDetails(user_id);
//       dispatch(setUserDetails(res.data));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleUploadClick = (id) => {
//     fileInputRefs.current[id].click();
//   };

//   // Submit LOR Files
//   const handleSubmit = async () => {
//     const uploadedFiles = lorFiles.filter((lor) => lor.status === "completed");
//     if (uploadedFiles.length === 0) {
//       alert("Please upload at least one LOR file.");
//       return;
//     }

//     setIsSubmitting(true);
//     const formData = new FormData();
//     formData.append("document_type", "lor");

//     uploadedFiles.forEach((lor) => {
//       if (lor.file) {
//         formData.append("files", lor.file, lor.name);
//       }
//     });

//     try {
//       const response = await uploadDocuments(formData);
//       alert("LOR files uploaded successfully!");

//       if (socket) {
//         socket.send(
//           JSON.stringify({
//             file_urls: response.data.uploaded_urls,
//             sender_id: user_id,
//             receiver_id:
//               studentDetails.assigned_admins.assigned_content_writer?.id,
//             room: socket.url.split("/")[5],
//           })
//         );
//       }
//     } catch (error) {
//       console.error("Upload Error:", error);
//       alert("Failed to upload LOR files.");
//     } finally {
//       setIsSubmitting(false);
//       await getStudentProfile(user_id);
//     }
//   };
//   const handleDownload = async () => {
//     if (!selectedCategory) return;

//     try {
//       const data = await fetchSampleDocumentDetails(selectedCategory);

//       // const docEntry = data?.find(
//       //   (entry) => entry.student_level === selectedCategory
//       // );
//       // "docEntry", docEntry);

//       const fileUrl = data?.lor_doc?.[0]; // Use "cv_resume" or "lor_doc" in CV or LOR section

//       if (!fileUrl) {
//         alert("No SOP file available for this category.");
//         return;
//       }

//       const link = document.createElement("a");
//       link.href = `${process.env.REACT_APP_BASE_URL}/media/${fileUrl}`;
//       link.setAttribute("download", fileUrl.split("/").pop());
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Failed to download SOP:", error);
//       alert("Error downloading SOP file.");
//     }
//   };

//   const handleRemoveFile = (id) => {
//     setLorFiles((prev) => prev.filter((lor) => lor.id !== id));
//   };

//   useEffect(() => {
//     if (studentDetails?.lor_url) {
//       setLorFiles(
//         studentDetails.lor_url.map((url, index) => ({
//           id: index + 1,
//           name: decodeURIComponent(url.split(/[/\\]/).pop()), // decode here
//           progress: 100,
//           status: "completed",
//         }))
//       );
//     }
//   }, [studentDetails.lor_url]);

//   return (
//     <>
//       <div className="space-y-4 mt-4">
//         <QuestionaireDownload
//           text={"Download LOR Questionaire"}
//           selectedCategory={selectedCategory}
//           setSelectedCategory={setSelectedCategory}
//           handleDownload={handleDownload}
//           studentLevels={studentLevels}
//         />
//         <div className="bg-gray-100 p-4 rounded-md flex flex-col">
//           <div className="flex items-center justify-between">
//             <div className="text-gray-700 font-medium">Upload LORs</div>
//             <div className="flex flex-col">
//               <div
//                 className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center cursor-pointer hover:border-purple-600 transition w-[300px]"
//                 onClick={() => fileInputRefs.current?.click()}
//               >
//                 <span className="text-gray-500">
//                   Click here to upload LOR files
//                 </span>
//               </div>
//               <input
//                 type="file"
//                 multiple
//                 ref={fileInputRefs}
//                 style={{ display: "none" }}
//                 accept=".doc,.docx"
//                 onChange={handleFileChange}
//               />
//             </div>
//           </div>

//           {/* Uploaded LOR previews */}
//           {lorFiles.map((lor) => (
//             <div
//               key={lor.id}
//               className="mt-2 text-gray-600 flex items-center justify-between"
//             >
//               <div>
//                 <b>{decodeURIComponent(lor.name.split(/[/\\]/).pop())}</b>{" "}
//                 {lor.status === "uploading" && (
//                   <div className="w-full h-2 bg-gray-200 rounded mt-1">
//                     <div
//                       className="h-2 bg-green-500 rounded"
//                       style={{ width: `${lor.progress}%` }}
//                     ></div>
//                   </div>
//                 )}
//                 {lor.status === "completed" && " (Uploaded)"}
//               </div>

//               <button
//                 className="text-red-500 hover:underline text-sm ml-4"
//                 onClick={() => handleRemoveFile(lor.id)}
//               >
//                 Remove
//               </button>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="flex justify-between items-center mt-4">
//         <div className="text-gray-500 text-sm">
//           <p>Please upload your documents in Word Document only</p>
//         </div>
//         <div className="flex justify-end gap-5">
//           <button type="button" className="text-gray-600 hover:text-gray-800">
//             Cancel
//           </button>
//           <button
//             type="submit"
//             className={`bg-purple-600 text-white px-4 py-2 rounded-md flex items-center gap-2 ${
//               isSubmitting ? "opacity-70 cursor-not-allowed" : ""
//             }`}
//             onClick={handleSubmit}
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? <Loader /> : "Submit"}
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LOR;
import React, { useEffect, useRef, useState } from "react";
import QuestionaireDownload from "../../common/QuestionaireDownload";
import {
  fetchDocumentOption,
  fetchSampleDocumentDetails,
  uploadDocuments,
} from "../../../services/user.services";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../admin/leads/Loader";
import { Cloud, FileText, XCircle, Download, ChevronDown } from "lucide-react";
import { getStudentDetails } from "../../../services/admin.services";
import { setUserDetails } from "../../../state/reducers/userSlice";

// ✅ Import WebSocket provider (same as Comments.jsx)
import { useWebSocket } from "../../../state/reducers/WebSocketProvider";

const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

const LOR = () => {
  const dispatch = useDispatch();
  const user_id = useSelector((state) => state.user.user_id);
  const studentDetails = useSelector((state) => state.user.userDetails);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lorFiles, setLorFiles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const fileInputRefs = useRef({});
  const [studentLevels, setStudentLevels] = useState([]);

  // ✅ Use WebSocket provider (don't create connection, just use existing one)
  const { sendMessage, getConnectionState } = useWebSocket();

  // ✅ Room key matches Comments.jsx routing logic
  const roomKey = "lor";

  const receiverId =
    studentDetails?.assigned_admins?.assigned_content_writer?.id || null;

  // ✅ Get connection state (created by Comments component)
  const connectionState = getConnectionState(roomKey, user_id);

  const fetchLevels = async () => {
    try {
      const data = await fetchDocumentOption();
      const levels = [...new Set(data.map((item) => item.student_level))];
      setStudentLevels(levels);
    } catch (error) {
      console.error("Error fetching document options:", error);
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  // ✅ Monitor connection state
  useEffect(() => {
    console.log("🔍 LOR connection state:", {
      roomKey,
      status: connectionState?.status,
      receiverId,
    });
  }, [connectionState, roomKey, receiverId]);

  const initializedLorRef = useRef(false);

  useEffect(() => {
    if (!studentDetails?.lor_url) return;
    if (initializedLorRef.current) return;

    setLorFiles(
      studentDetails.lor_url.map((url, index) => ({
        id: `server_${index}`, // stable id
        url, // keep original url if needed
        name: decodeURIComponent(url.split(/[/\\]/).pop()),
        progress: 100,
        status: "completed",
        source: "server",
      }))
    );

    initializedLorRef.current = true;
  }, [studentDetails?.lor_url]);

  // Initialize LOR fields dynamically based on existing lor_url length
  // useEffect(() => {
  //   if (studentDetails?.lor_url) {
  //     setLorFiles(
  //       studentDetails.lor_url.map((url, index) => ({
  //         id: index + 1,
  //         name: decodeURIComponent(url.split(/[/\\]/).pop()),
  //         progress: 100,
  //         status: "completed",
  //       }))
  //     );
  //   }
  // }, [studentDetails?.lor_url]);

  // Add new LOR field dynamically
  const addMoreLor = () => {
    setLorFiles((prev) => [
      ...prev,
      { id: prev.length + 1, name: "", progress: 0, status: "idle" },
    ]);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newLorFiles = files.map((file, index) => ({
      id: lorFiles.length + index + 1,
      name: file.name,
      progress: 0,
      status: "uploading",
      file,
    }));

    setLorFiles((prev) => [...prev, ...newLorFiles]);

    newLorFiles.forEach((lor) => uploadFile(lor.id, lor.file));
  };

  // Simulate upload progress (Replace with actual upload API call)
  const uploadFile = (id, file) => {
    const interval = setInterval(() => {
      setLorFiles((prevFiles) =>
        prevFiles.map((lor) => {
          if (lor.id === id) {
            if (lor.progress >= 100) {
              clearInterval(interval);
              return { ...lor, progress: 100, status: "completed" };
            }
            return { ...lor, progress: lor.progress + 5 };
          }
          return lor;
        })
      );
    }, 50);
  };
  initializedLorRef.current = false;

  const getStudentProfile = async (user_id) => {
    try {
      const res = await getStudentDetails(user_id);
      dispatch(setUserDetails(res.data));
    } catch (err) {
      console.error(err);
    }
  };

  const handleUploadClick = (id) => {
    fileInputRefs.current[id].click();
  };

  // ✅ Upload files to chat backend (same as Comments.jsx)
  const uploadFilesToChat = async (files) => {
    if (!files || files.length === 0) return [];

    try {
      const formData = new FormData();
      const fileArray = Array.isArray(files) ? files : [files];

      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      // Add metadata
      const roomname = `${roomKey}_${user_id}`;
      formData.append("roomname", roomname);
      formData.append("sender_id", user_id);

      console.log("📤 LOR: Uploading files to chat backend:", {
        roomname,
        fileCount: fileArray.length,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Chat file upload failed");
      }

      const data = await response.json();
      console.log("✅ LOR: Chat files uploaded:", data);

      return data.file_urls || [];
    } catch (error) {
      console.error("❌ LOR: Chat file upload error:", error);
      throw error;
    }
  };

  // Submit LOR Files
  const handleSubmit = async () => {
    const uploadedFiles = lorFiles.filter((lor) => lor.status === "completed");
    if (uploadedFiles.length === 0) {
      alert("Please upload at least one LOR file.");
      return;
    }

    if (!receiverId) {
      alert("Assigned content writer not found. Please contact support.");
      return;
    }

    // ✅ Check if connection exists (from Comments component)
    if (!connectionState || connectionState.status !== "connected") {
      alert(
        "Chat is not connected. Please open the chat tab first and try again."
      );
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("document_type", "lor");

    uploadedFiles.forEach((lor) => {
      if (lor.file) {
        formData.append("files", lor.file, lor.name);
      }
    });

    try {
      // ✅ STEP 1: Upload to document system
      console.log("📤 LOR Step 1: Uploading to document system...");
      const response = await uploadDocuments(formData);

      // ✅ STEP 2: Upload to chat system (only files with .file property)
      const filesToUploadToChat = uploadedFiles
        .filter((lor) => lor.file)
        .map((lor) => lor.file);

      if (filesToUploadToChat.length > 0) {
        console.log("📤 LOR Step 2: Uploading to chat system...");
        const chatFileUrls = await uploadFilesToChat(filesToUploadToChat);

        if (!chatFileUrls || chatFileUrls.length === 0) {
          throw new Error("Failed to upload files to chat system");
        }

        // ✅ STEP 3: Send message via existing WebSocket connection
        console.log("📤 LOR Step 3: Sending message with file attachments...");
        const cid = genId();

        sendMessage(roomKey, user_id, {
          message: `✅ ${filesToUploadToChat.length} LOR file(s) uploaded successfully`,
          sender_id: user_id,
          receiver_id: receiverId,
          client_message_id: cid,
          file_urls: chatFileUrls,
        });

        console.log("✅ LOR upload and chat notification complete");
      }

      alert("LOR files uploaded successfully!");

      // Refresh student profile
      await getStudentProfile(user_id);
    } catch (error) {
      console.error("❌ Upload Error:", error);
      alert(error.message || "Failed to upload LOR files. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownload = async () => {
    if (!selectedCategory) return;

    try {
      const data = await fetchSampleDocumentDetails(selectedCategory);
      const fileUrl = data?.lor_doc?.[0];

      if (!fileUrl) {
        alert("No LOR sample available for this category.");
        return;
      }

      const link = document.createElement("a");
      link.href = `${process.env.REACT_APP_BASE_URL}/media/${fileUrl}`;
      link.setAttribute("download", fileUrl.split("/").pop());
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download LOR sample:", error);
      alert("Error downloading LOR sample file.");
    }
  };

  const handleRemoveFile = (id) => {
    setLorFiles((prev) => prev.filter((lor) => lor.id !== id));
  };

  return (
    <>
      <div className="space-y-4 mt-4">
        <QuestionaireDownload
          text={"Download LOR Questionnaire"}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          handleDownload={handleDownload}
          studentLevels={studentLevels}
        />

        {/* ✅ CONNECTION STATUS WARNINGS */}
        {!connectionState?.status && (
          <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-yellow-800 text-sm font-medium">
              ⚠️ Chat not connected
            </p>
            <p className="text-yellow-600 text-xs mt-1">
              Please open the "LOR" chat tab first to enable notifications.
            </p>
          </div>
        )}

        {connectionState?.status === "connecting" && (
          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="text-blue-800 text-sm">
                Chat is connecting...
              </span>
            </div>
          </div>
        )}

        {connectionState?.status === "connected" && (
          <div className="mb-4 flex items-center gap-2">
            <span className="flex items-center gap-1 text-xs text-green-600">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              Chat connected - uploads will notify admin
            </span>
          </div>
        )}

        {!receiverId && studentDetails && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm font-medium">
              ⚠️ No content writer assigned
            </p>
            <p className="text-red-600 text-xs mt-1">
              Please contact support to assign a content writer before
              uploading.
            </p>
          </div>
        )}

        <div className="bg-gray-100 p-4 rounded-md flex flex-col">
          <div className="flex items-center justify-between">
            <div className="text-gray-700 font-medium">Upload LORs</div>
            <div className="flex flex-col">
              <div
                className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center cursor-pointer hover:border-purple-600 transition w-[300px]"
                onClick={() => fileInputRefs.current?.click()}
              >
                <span className="text-gray-500">
                  Click here to upload LOR files
                </span>
              </div>
              <input
                type="file"
                multiple
                ref={fileInputRefs}
                style={{ display: "none" }}
                accept=".doc,.docx"
                onChange={handleFileChange}
              />
            </div>
          </div>

          {/* Uploaded LOR previews */}
          {lorFiles.map((lor) => (
            <div
              key={lor.id}
              className="mt-2 text-gray-600 flex items-center justify-between"
            >
              <div>
                <b>{decodeURIComponent(lor.name.split(/[/\\]/).pop())}</b>{" "}
                {lor.status === "uploading" && (
                  <div className="w-full h-2 bg-gray-200 rounded mt-1">
                    <div
                      className="h-2 bg-green-500 rounded"
                      style={{ width: `${lor.progress}%` }}
                    ></div>
                  </div>
                )}
                {lor.status === "completed" && " (Uploaded)"}
              </div>

              <button
                className="text-red-500 hover:underline text-sm ml-4"
                onClick={() => handleRemoveFile(lor.id)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-between items-center mt-4">
        <div className="text-gray-500 text-sm">
          <p>Please upload your documents in Word Document only</p>
        </div>
        <div className="flex justify-end gap-5">
          <button type="button" className="text-gray-600 hover:text-gray-800">
            Cancel
          </button>
          <button
            type="submit"
            className={`bg-purple-600 text-white px-4 py-2 rounded-md flex items-center gap-2 ${
              isSubmitting || connectionState?.status !== "connected"
                ? "opacity-70 cursor-not-allowed"
                : ""
            }`}
            onClick={handleSubmit}
            disabled={isSubmitting || connectionState?.status !== "connected"}
          >
            {isSubmitting ? <Loader /> : "Submit"}
          </button>
        </div>
      </div>
    </>
  );
};

export default LOR;
